import type {EditorState} from '../../vendor/src/features/remotion-editor/editor/state/types';
import type {EditorStarterAsset} from '../../vendor/src/features/remotion-editor/editor/assets/assets';
import type {CompanyUploadedMedia} from '../../protocol/work-session';
import {planSourceVideoReplacement,type SourceVideoReplacementAuthority} from './source-video-replacement';
import {hasPendingTimelineEdit} from './edit-ownership';
import {nativeSceneGenerationSemantics} from './source-scene-generation-semantics';
/** Run inside the state updater: transient gesture flags do not change document identity. */
export function commitSourceSceneOutput(current:EditorState,expected:EditorState['undoableState'],next:EditorState,mode:'replaced'|'library'|'already'):EditorState|null {
 if(current.undoableState!==expected||(mode==='replaced'&&hasPendingTimelineEdit(current)))return null;
 return {...current,undoableState:next.undoableState,assetStatus:next.assetStatus};
}
/** Actual uploaded-media F branch: uploaded output survives stale sources; never appends a clip. */
export async function receiveSourceSceneOutput(media:CompanyUploadedMedia,asset:EditorStarterAsset,deps:{
 getState():EditorState;isLive():boolean;authority():SourceVideoReplacementAuthority;
 commit(expected:EditorState['undoableState'],next:EditorState,mode:'replaced'|'library'|'already'):boolean;
}){
 if(!deps.isLive()||!media.sourceSceneGeneration||!media.attachmentId||asset.type!=='video')throw Error('씬 생성 영상의 작업 연결을 확인해 주세요.');
 // Replan once after an atomic rejection so a newly started gesture retains the
 // result in the library without placing it or overwriting current editor flags.
 for(let attempt=0;attempt<2;attempt++){
  if(!deps.isLive())break;
  const base=deps.getState(),authority=deps.authority();
  const plan=await planSourceVideoReplacement(base,asset,media.sourceSceneGeneration,media.attachmentId,{...authority,...(media.sourceSceneRevision?{revision:media.sourceSceneRevision}:{})},nativeSceneGenerationSemantics,Date.now());
  if(plan.mode==='already'||(deps.isLive()&&deps.commit(base.undoableState,plan.state,plan.mode)))return plan;
 }
 throw Error('영상 결과는 보관되어 있습니다. 편집이 바뀌어 전달을 마치지 못했습니다. 같은 결과를 다시 전달해 주세요.');
}
